module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAQCAYAAAD9L+QYAAAAeUlEQVQ4je3UsQ3CQAxA0e9Lh9IxAVKoswDL3WywQKpIJCOQGT4NJShFzh2/tfQq26HegRvte4T6As4J+BbqBRgT8CnUQ0Kt9eesHJJ3SsVDPQFXIBq6Akuozw/euqUAXQIM0IXaA0MCvv5X8Wvp55/2uAowJ8AA8xuI9y+AGsOmYQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/zhedie.png
// module id = gV3W
// module chunks = 1